export const MIN_ADDRESS_LENGTH = 8;

export function collapseConsecutiveSpaces(value: unknown): string {
  let result = String(value ?? '');
  while (result.includes('  ')) {
    result = result.replace(/ {2,}/g, ' ');
  }
  return result.trim();
}

export function hasMinAddressLength(value: unknown): boolean {
  return collapseConsecutiveSpaces(value).length >= MIN_ADDRESS_LENGTH;
}
